import React, {useEffect, useState} from 'react';
import {Box, List, Typography} from '@mui/material';
import {getLesson} from '../http/academyAPI';
import {useParams} from 'react-router-dom';

const LessonDetails = () => {
    const {id} = useParams();
    const [lesson, setLesson] = useState({
        name: '',
        description: '',
        content: [],
        videoUrl: '',
    });

    useEffect(() => {
        const fetchLesson = async () => {
            try {
                const data = await getLesson(id);
                let parsedContent = [];
                if (typeof data.content === 'string') {
                    const contentString = data.content.replace(/[{ }]/g, '').split(',');
                    parsedContent = contentString.map((item) => item.replace(/"/g, '').trim());
                }

                setLesson({
                    name: data.name,
                    description: data.description,
                    content: parsedContent,
                    videoUrl: data.videoUrl,
                });
            } catch (error) {
                console.error('Ошибка при получении урока:', error);
                setLesson({name: '', description: '', content: [], videoUrl: ''});
            }
        };

        fetchLesson();
    }, [id]);

    const getVideoUrl = (url) => {
        if (!url) return '';

        // Проверяем, есть ли протокол
        if (!/^https?:\/\//i.test(url)) {
            url = `https://${url}`;
        }

        // Проверяем, является ли видео приватным
        const privateVideoMatch = url.match(/video\/private\/([a-zA-Z0-9]+)\/\?p=([a-zA-Z0-9_-]+)/);
        if (privateVideoMatch) {
            const videoId = privateVideoMatch[1];
            const accessKey = privateVideoMatch[2];
            return `https://rutube.ru/play/embed/${videoId}/?p=${accessKey}`;
        }

        // Преобразуем URL в формат встраивания
        const videoIdMatch = url.match(/video\/([a-zA-Z0-9]+)/);
        if (videoIdMatch) {
            return `https://rutube.ru/play/embed/${videoIdMatch[1]}`;
        }

        // Если URL уже в формате встраивания, возвращаем его
        const embedMatch = url.match(/play\/embed\/(\w+)/);
        if (embedMatch) {
            return url; // Возвращаем, если это уже встраиваемый URL
        }

        // Если ничего не найдено, возвращаем оригинальный URL
        return url;
    };

    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'start',
                marginBottom: 2,
                width: '100%',
            }}
        >
            <Typography variant='h5' component='h1' sx={{fontWeight: 'bold', marginBottom: 2}}>
                {lesson.name}
            </Typography>
            <Box
                mb={2}
                borderRadius={'5px'}
                overflow='hidden'
                border={1}
                height={500}
                width={888}
                borderColor='grey.400'
            >
                <iframe
                    src={getVideoUrl(lesson.videoUrl)} // Убедитесь, что lesson.videoUrl содержит корректный URL
                    style={{border: 'none'}}
                    height={'100%'}
                    width={'100%'}
                    title='rutube'
                    allow='clipboard-write; autoplay'
                    webkitAllowFullScreen
                    mozallowfullscreen
                    allowFullScreen
                    loading='lazy'
                />

            </Box>
            <Typography sx={{fontSize: '14px', opacity: 0.5, color: '#c97435'}}><i>* Если видео-инструкция не загружается, то откройте в браузере Rutube и авторизуйтесь,
                после вернитесь на данную страницу и видео запустится.</i></Typography>

            {
                lesson.content?.length > 0 && lesson.content[0].length > 0 && (
                    <>
                        <Typography variant='h6' component='h2' sx={{fontWeight: 'bold', marginBottom: 1}}>
                        </Typography>
                        <List>
                            {lesson.content.map((item, index) => (
                                <Typography component={'li'} key={index}>
                                    <pre>{item}</pre>
                                </Typography>
                            ))}
                        </List>
                    </>
                )
            }

            <Typography color='textSecondary' sx={{fontSize: '14px', marginTop: 2}}>
                <pre>{lesson.description}</pre>
            </Typography>
        </Box>
    );
};

export default LessonDetails;
